/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { combineReducers } from "redux";
import loginReducer from "./authentication/login/loginReducer";
import resetPasswordReducer from "./authentication/change-password/changePasswordReducer";
import {
  setPasswordReducer,
  setPasswordForNewUserReducer,
  setNewPasswordReducer,
} from "./authentication/set-password/setPasswordReducer";
import {
  forgotPasswordReducer,
  validateOtpForForgotPasswordReducer,
} from "./authentication/forgot-password/forgotPasswordReducer";
import profileReducer from "./profile/profileReducer";

import {
  issuesReducer,
  createIssueReducer,
  requestTypesReducer,
  supportHomePageReducer,
  issueStatusReducer,
  issueCommentsReducer,
  addIssueCommentReducer,
  reopenIssueReducer,
  addAttachmentsReducer,
  reportedTicketsReducer,
  // getTicketsByStatusReducer,
  getTicketsByStatusForCompletedReducer,
  getTicketsForActiveReducer,
  homeTicketDetailsReducer,
  getCompletedTicketsReducer,
} from "./tickets/ticketsReducer";

import nodesReducer from "./nodes/nodesReducer";

import { subscriptionHomepageReducer } from "./subscription/subscriptionReducer";
import {
  adminReducer,
  createAdminReducer,
  deleteAdminReducer,
  editAdminReducer,
} from "./admin-creation/adminReducer";
import {
  UserReducer,
  createUserReducer,
  deleteUserReducer,
  editUserReducer,
} from "./users/usersReducer";
import {
  UsersByclientReducer,
  addAttachmentsReducerForClient,
  addIssueCommentReducerForClient,
  createIssueReducerForClient,
  getCompletedTicketsForClientReducer,
  getTicketsForCompletedReducer,
  getTicketsStatusForActiveReducer,
  homePageForClientTickets,
  issueCommentsReducerForClient,
  issueStatusReducerForClient,
  reopenIssueReducerForClient,
  reportedTicketsReducerForClient,
  requestTypesReducerForClient,
} from "./client-tickets/clientTicketReducer";
import { getClientsForDropdownReducer, getClientsReducer, getClientTicketReducer, getOrgReducer } from "./clients/clientsReducer";
import { createAdminRegistrationReducer } from "./admin-registration/adminRegistrationReducer";

const rootReducer = combineReducers({
  login: loginReducer,
  resetPassword: resetPasswordReducer,
  setPasswordReducer: setPasswordReducer,
  setPasswordForNewUserReducer: setPasswordForNewUserReducer,
  setNewPasswordReducer: setNewPasswordReducer,
  forgotPassword: forgotPasswordReducer,
  validateOtpForForgotPasswordReducer: validateOtpForForgotPasswordReducer,
  profile: profileReducer,

  // issues: issuesReducer,
  reportedTicketsReducer: reportedTicketsReducer,
  createIssueReducer: createIssueReducer,
  addAttachmentsReducer: addAttachmentsReducer,
  requestTypes: requestTypesReducer,
  supportHomePageReducer: supportHomePageReducer,
  issueStatusReducer: issueStatusReducer,
  issueCommentsReducer: issueCommentsReducer,

  nodes: nodesReducer,

  subscriptionHomepage: subscriptionHomepageReducer,
  addIssueCommentReducer: addIssueCommentReducer,
  reopenIssueReducer: reopenIssueReducer,
  adminReducer: adminReducer,
  createAdminReducer: createAdminReducer,
  editAdminReducer: editAdminReducer,
  deleteAdminReducer: deleteAdminReducer,
  UserReducer: UserReducer,
  createUserReducer: createUserReducer,
  editUserReducer: editUserReducer,
  deleteUserReducer: deleteUserReducer,
  reportedTicketsReducerForClient: reportedTicketsReducerForClient,
  createIssueReducerForClient: createIssueReducerForClient,
  requestTypesReducerForClient: requestTypesReducerForClient,
  addAttachmentsReducerForClient: addAttachmentsReducerForClient,
  issueStatusReducerForClient: issueStatusReducerForClient,
  issueCommentsReducerForClient: issueCommentsReducerForClient,
  addIssueCommentReducerForClient: addIssueCommentReducerForClient,
  reopenIssueReducerForClient: reopenIssueReducerForClient,
  // supportHomePageReducerForClient: supportHomePageReducerForClient,
  homePageForClientTickets: homePageForClientTickets,
  getClientsReducer: getClientsReducer,
  createAdminRegistrationReducer: createAdminRegistrationReducer,
  UsersByclientReducer: UsersByclientReducer,
  getCompletedTicketsForClientReducer: getCompletedTicketsForClientReducer,
  getTicketsByStatusForCompletedReducer: getTicketsByStatusForCompletedReducer,
  getTicketsForActiveReducer: getTicketsForActiveReducer,
  getTicketsForCompletedReducer: getTicketsForCompletedReducer,
  getTicketsStatusForActiveReducer: getTicketsStatusForActiveReducer,
  homeTicketDetailsReducer: homeTicketDetailsReducer,
  getCompletedTicketsReducer: getCompletedTicketsReducer,
  getOrgReducer: getOrgReducer,
  getClientsForDropdownReducer: getClientsForDropdownReducer,
  getClientTicketReducer: getClientTicketReducer,
});

export default rootReducer;
